export const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/home/index')
  },
  {
    path: '/resourceList',
    name: 'resourceList',
    component: () => import('@/views/resourceList/index')
  },
  // 关系图谱
  // {
  //   path: '/relation',
  //   name: 'relation',
  //   component: () => import('@/views/relation/index')
  // },
  // 年鉴
  // {
  //   path: '/resourceList/yearBooks',
  //   component: () => import('@/views/yearBooks/index'),
  //   children: [
  //     {
  //       path: '/',
  //       component: () => import('@/views/yearBooks/year/index')
  //     },
  //     {
  //       path: 'part',
  //       component: () => import('@/views/yearBooks/part/index')
  //     },
  //     {
  //       path: 'search',
  //       component: () => import('@/views/yearBooks/search/index')
  //     }
  //   ]
  // },
  // 县志
  {
    path: '/resourceList/countyAnnals',
    component: () => import('@/views/countyAnnals/index'),
    children: [
      {
        path: '/',
        component: () => import('@/views/countyAnnals/directory/index')
      },
      {
        path: 'search',
        component: () => import('@/views/countyAnnals/search/index')
      }
    ]
  },
  // 行业志
  {
    path: '/resourceList/industryAnnals',
    component: () => import('@/views/industryAnnals/index'),
    children: [
      {
        path: '/',
        component: () => import('@/views/industryAnnals/directory/index')
      },
      {
        path: 'search',
        component: () => import('@/views/industryAnnals/search/index')
      }
    ]
  }
  // 地情资料
  // {
  //   path: '/resourceList/geological',
  //   component: () => import('@/views/geological/index'),
  //   children: [
  //     {
  //       path: '/',
  //       component: () => import('@/views/geological/directory/index')
  //     },
  //     {
  //       path: 'search',
  //       component: () => import('@/views/geological/search/index')
  //     }
  //   ]
  // }
  // 古籍
  // {
  //   path: '/ancientBooks',
  //   name: 'ancientBooks',
  //   components: {
  //     pageTwo: () => import('@/views/ancientBooks/index')
  //   }
  // },
  // {
  //   path: '/digitalBooks',
  //   name: 'digitalBooks',
  //   components: {
  //     pageTwo: () => import('@/views/digitalBooks/index')
  //   }
  // },
  // {
  //   path: '/digitalBooks/bookDetails/:id',
  //   name: 'bookDetails',
  //   components: {
  //     pageTwo: () => import('@/views/bookDetails/index')
  //   }
  // }
]
